import FHIR from 'fhirclient';

/**
 * R3-1 (Round 3 smoke, 2026-06-11) — single-flight wrapper around
 * fhirclient's oauth2.ready().
 *
 * On /callback, BOTH SmartCallback (the route component) and
 * AuthProvider's init effect called FHIR.oauth2.ready() in the same
 * mount tick. Each call independently saw the `code` in the URL and
 * started its own token exchange in parallel — KC redeems the code for
 * whichever request lands first and rejects the second with
 * `invalid_grant: Code not valid`. The loser rendered "Authorization
 * Failed" even though the winner's session was perfectly good.
 *
 * SmartCallback's sessionStorage consumed-code guard can't help here:
 * both calls start before either has finished, so neither sees the
 * other's flag in time. The only safe shape is ONE module-level
 * promise that every caller shares.
 *
 * On failure the memo is cleared so a deliberate retry (fresh launch)
 * isn't poisoned by a stale rejection.
 */
let _readyPromise = null;

export function smartReady() {
  if (!_readyPromise) {
    _readyPromise = FHIR.oauth2.ready().catch((err) => {
      _readyPromise = null;
      throw err;
    });
  }
  return _readyPromise;
}
